import { Formik } from 'formik';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { API_URL, PACKAGE_TYPES } from '../../../../utils/constants';
import AutocompleteComponent from '../../../../components/common/forms/Autcomplete/AutocompleteComponent';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from './validationSchemaPackageRow';
import PackagedProductsApi from '../../../../services/api/PackagedProductsApi';
import ButtonComponent from '../../../../components/common/forms/Button/ButtonComponent';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';
import xIcon from '~/src/static/img/xIcon.svg';
import styled from 'styled-components';

interface PackageRowProps {
  packagedProduct?: {
    id?: number | null;
    packId?: string;
    smallerUnitId?: number | null;
    numberSmallerUnits?: number | null;
    gtin?: string;
    width?: string;
    length?: string;
    height?: string;
    netWeight?: string;
    grossWeight?: string;
    maxLabelWidth?: string;
    maxLabelHeight?: string;
    weightCapacity?: string;
  };
  onDelete: () => void;
}

export default function PackageRow({
  packagedProduct = {
    id: null,
    packId: '',
    smallerUnitId: null,
    numberSmallerUnits: null,
    gtin: '',
    width: '',
    length: '',
    height: '',
    netWeight: '',
    grossWeight: '',
    maxLabelWidth: '',
    maxLabelHeight: '',
    weightCapacity: '',
  },
  onDelete,
}): JSX.Element {
  const [packagedProductIdLocal, setUniqueProductPackageIdLocal] = useState(packagedProduct.id);

  const saveItem = async (values) => {
    await PackagedProductsApi.update(packagedProductIdLocal, {
      ...values,
      packagedProductId: packagedProduct.id,
    });
  };

  return (
    <Formik
      initialValues={{
        packId: packagedProduct.packId,
        smallerUnitId: packagedProduct.smallerUnitId || '',
        numberSmallerUnits: packagedProduct.numberSmallerUnits || '',
        gtin: packagedProduct.gtin || '',
        width: packagedProduct.width || '',
        length: packagedProduct.length || '',
        height: packagedProduct.height || '',
        netWeight: packagedProduct.netWeight || '',
        grossWeight: packagedProduct.grossWeight || '',
        maxLabelWidth: packagedProduct.maxLabelWidth || '',
        maxLabelHeight: packagedProduct.maxLabelHeight || '',
        weightCapacity: packagedProduct.weightCapacity || '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        return saveItem(values, setSubmitting);
      }}
      // validateOnBlur
    >
      {({ values, handleChange, handleSubmit, errors, setFieldValue, touched }) => (
        // <div onSubmit={handleSubmit} autoComplete="off">
        <StyleTr>
          <StyledTd>
            <StyledP>{packagedProduct?.pack?.name}</StyledP>
          </StyledTd>
          {/* {packagedProduct.pack.type === PACKAGE_TYPES.CONSUMER_UNIT ? (
            <StyledTd>
              <div className="form-group col-sm-1">&nbsp;</div>
              <div className="form-group col-sm-1">&nbsp;</div>
            </StyledTd>
          ) : ( */}

          <StyledTd>
            <TextInputComponent
              name="numberSmallerUnits"
              value={values.numberSmallerUnits}
              onBlur={async () => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              errors={errors}
              touched={touched}
              height="25"
            />
          </StyledTd>
          <StyledTd style={{ width: '150px' }}>
            <AutocompleteComponent
              url={`${API_URL}/products/packaged-products/others/${packagedProduct.id}`}
              name="smallerUnitId"
              initialValue={values.smallerUnitId}
              onChange={(e, v) => {
                setFieldValue(e, v);
                handleSubmit();
              }}
              cols={12}
              getOptionLabel={(option) => `${option.pack.name}`}
              errorMessage={errors.smallerUnitId || null}
              height={25}
            />
          </StyledTd>
          {/* )} */}
          <StyledTd>
            <TextInputComponent
              name="width"
              value={values.width}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="length"
              value={values.length}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="height"
              value={values.height}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="netWeight"
              value={values.netWeight}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="grossWeight"
              value={values.grossWeight}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="maxLabelWidth"
              value={values.maxLabelWidth}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="maxLabelHeight"
              value={values.maxLabelHeight}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="gtin"
              value={values.gtin}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              height="25"
            />
          </StyledTd>
          <StyledTd>
            <TextInputComponent
              name="weightCapacity"
              value={values.weightCapacity}
              onBlur={() => {
                handleSubmit();
              }}
              onChange={handleChange}
              cols={12}
              type="number"
              height="25"
            />
          </StyledTd>
          <StyledTd>
            {packagedProduct.pack.type !== PACKAGE_TYPES.CONSUMER_UNIT &&
            packagedProduct.pack.type !== PACKAGE_TYPES.DISTRIBUTION_UNIT ? (
              <BorderlessButton icon={xIcon} onClick={() => onDelete(packagedProduct.id)} />
            ) : (
              <BorderlessButton onClick={() => onDelete(packagedProduct.id)} />
            )}
          </StyledTd>
        </StyleTr>
      )}
    </Formik>
  );
}

const StyleTr = styled.tr``;

const StyledTd = styled.td`
  vertical-align: middle;
  padding: 3px;

  border: 1px solid #fff;
`;

const StyledP = styled.p`
  color: #642b26;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  margin: 0;
`;
